import { render, staticRenderFns } from "./editInfo.vue?vue&type=template&id=b04a8bfc&scoped=true"
import script from "./editInfo.vue?vue&type=script&lang=js"
export * from "./editInfo.vue?vue&type=script&lang=js"
import style0 from "./editInfo.vue?vue&type=style&index=0&id=b04a8bfc&prod&lang=css"
import style1 from "./editInfo.vue?vue&type=style&index=1&id=b04a8bfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04a8bfc",
  null
  
)

export default component.exports